import List from "@/components/list";

const Table = args => {
  const { listeners, props } = args;
  const handleDelete = listeners["handleDelete"] || function () { };
  // 合并列
  function arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
    if (columnIndex < 3) {
      const dataProvider = args.props.data;
      const cellValue = row[column.property]
      if (cellValue) {
        // 上一条数据
        const prevRow = dataProvider[rowIndex - 1]
        // 下一条数据
        let nextRow = dataProvider[rowIndex + 1]
        // 当上一条数据等于下一条数据
        if (prevRow && prevRow[column.property] === cellValue && (prevRow.userId == row.userId)) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let rowspan = 1
          while (nextRow && nextRow[column.property] === cellValue && (nextRow.userId == row.userId)) {
            rowspan++
            nextRow = dataProvider[rowspan + rowIndex]
          }
          if (rowspan > 1) {
            return { rowspan, colspan: 1 }
          }
        }
      }
    }
  }

  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      [
        "icon-delete",
        "删除",
        () => handleDelete(vo.row),
        "topicLectureLearn:delete"
      ]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "姓名",
      prop: "userName",
      minWidth: "90",
    }, {
      label: "工作单位",
      prop: "deptName",
      minWidth: "120",
      //showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "120",
      // showOverflowTooltip: true
    },
    {
      label: "学习名称",
      prop: "lectureName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "学习时间",
      prop: "trainTimeStr",
      minWidth: "140",
      sortable: true
    },
    {
      label: "学时",
      prop: "lectureHours",
      minWidth: "80",
    },
    {
      label: "学习单位",
      prop: "organizer",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "学习地点",
      prop: "lecturePlace",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "参训时单位及职务",
      prop: "trainedUnitPosition",
      minWidth: "150",
      showOverflowTooltip: true
    },{
      label: "操作",
      fixed: "right",
      with: "40",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
        span-method={arraySpanMethod}
      />
    </div>
  );
};
export default Table;
